import React from 'react';

export const getKsefStatusBadge = (invoice) => {
  const status = invoice.ksef_status;
  if (!status) return null;

  const styles = {
    pending: { bg: 'var(--warning)', color: '#000', text: 'Oczekuje' },
    sent: { bg: 'var(--info)', color: '#fff' , text: 'Wyslana' },
    accepted: { bg: 'var(--success)', color: '#fff' , text: 'Zaakceptowana' },
    rejected: { bg: 'var(--danger)', color: '#fff' , text: 'Odrzucona' },
    error: { bg: 'var(--danger)', color: '#fff' , text: 'Blad' }
  };

  const style = styles[status] || { bg: 'var(--text-muted)', color: '#fff' , text: status };

  return (
    <span style={{
      padding: '0.15rem 0.4rem',
      borderRadius: '3px',
      fontSize: '9px',
      fontWeight: '500',
      backgroundColor: style.bg,
      color: style.color
    }} title={invoice.ksef_numer || invoice.ksef_error_message || ''}>
      {style.text}
      {invoice.ksef_numer && <span style={{ marginLeft: '3px', fontSize: '8px' }}>{'✓'}</span>}
    </span>
  );
};

export const getDateRange = (period) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  let from = null;
  let to = new Date();
  to.setHours(23, 59, 59, 999);

  switch (period) {
    case 'today':
      from = today;
      break;
    case 'week':
      from = new Date(today);
      from.setDate(today.getDate() - 7);
      break;
    case 'month':
      from = new Date(today.getFullYear(), today.getMonth(), 1);
      break;
    case 'year':
      from = new Date(today.getFullYear(), 0, 1);
      break;
    default:
      return { from: null, to: null };
  }
  return { from, to };
};

export const sortData = (data, sortColumn, sortDirection) => {
  return [...data].sort((a, b) => {
    let aVal = a[sortColumn];
    let bVal = b[sortColumn];

    if (aVal === null || aVal === undefined) aVal = '';
    if (bVal === null || bVal === undefined) bVal = '';

    if (sortColumn === 'suma_brutto') {
      aVal = parseFloat(aVal) || 0;
      bVal = parseFloat(bVal) || 0;
    }

    if (typeof aVal === 'number' && typeof bVal === 'number') {
      return sortDirection === 'asc' ? aVal - bVal : bVal - aVal;
    }

    const comparison = String(aVal).localeCompare(String(bVal), 'pl', { numeric: true });
    return sortDirection === 'asc' ? comparison : -comparison;
  });
};
